import { Controller } from "stimulus"
import './component.scss'

class StrongPointsController extends Controller {
  static targets = ["text", "button", "buttonTextSub", "buttonText"]
  static classes = ["expanded", "hidden"]

  connect() {
    this.isExpanded = false
    this.checkTextHeight()
  }

  checkTextHeight() {
    this.textTargets.forEach((text, index) => {
      const button = this.buttonTargets[index]
      if (!button) return

      // 一時的にline-clampを解除して全体の高さを測定
      text.classList.add(this.expandedClass)

      // DOM更新を待つ
      requestAnimationFrame(() => {
        const fullHeight = text.scrollHeight

        // line-clampを復元
        text.classList.remove(this.expandedClass)

        // DOM更新を再度待つ
        requestAnimationFrame(() => {
          const clampedHeight = text.offsetHeight

          // 4行以下の場合は「もっと見る」ボタンを非表示
          if (fullHeight <= clampedHeight + 5) { // 5pxのマージンを追加
            button.classList.add(this.hiddenClass)
          }
        })
      })
    })
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()

    // クリックされたボタンのインデックスを取得
    const button = event.currentTarget
    const buttonIndex = this.buttonTargets.indexOf(button)
    const text = this.textTargets[buttonIndex]
    const buttonTextSub = this.buttonTextSubTargets[buttonIndex]
    const buttonText = this.buttonTextTargets[buttonIndex]

    if (!text || !buttonTextSub || !buttonText) return


    if (!text.classList.contains(this.expandedClass)) {
      // 展開
      text.classList.add(this.expandedClass)
      button.classList.add(this.expandedClass)

      // ボタンのテキストを変更
      buttonTextSub.textContent = ''
      buttonText.textContent = '閉じる'
    } else {
      // 折りたたむ
      text.classList.remove(this.expandedClass)
      button.classList.remove(this.expandedClass)

      // ボタンのテキストを復元
      buttonTextSub.textContent = '...'
      buttonText.textContent = 'もっと見る'
    }
  }
}

// StimulusJSに登録
window.Stimulus.register('strong-points', StrongPointsController)
